(() => {
  if (window.chShopAllReady) return;
  window.chShopAllReady = true;
  const colorMap = {
    Beige: { swatch: '#cdb89c', pattern: /beige|cream|sand|sofita/i },
    White: { swatch: '#f2eee6', pattern: /white|ivory|carrara|carrera|thassos|arabescato|calacatta|calcatta|calcatta|off.white/i },
    Green: { swatch: '#405b48', pattern: /green|verde|verdy|verd[ei]|gucci|avocatus/i },
    Red: { swatch: '#814942', pattern: /red|rosso|burgundy|terracotta|alicante/i },
    Blue: { swatch: '#738d9e', pattern: /blue|navy|azure/i },
    Grey: { swatch: '#92928a', pattern: /gr[ea]y|silver|tundra/i },
    Black: { swatch: '#35312e', pattern: /black|nero|panda|grand antique/i },
    Yellow: { swatch: '#c5a34f', pattern: /yellow|honey|gold|giallo/i },
    Brown: { swatch: '#715043', pattern: /brown|emperador|walnut/i },
    Pink: { swatch: '#c68e84', pattern: /peach|pink|blush/i },
    Purple: { swatch: '#756171', pattern: /purple|viola/i },
    Multicolour: { swatch: 'conic-gradient(#814942,#cdb89c,#405b48,#738d9e,#814942)', pattern: /checkered|chequered|strata|estrata|multicolou?r/i }
  };
  const materialMap = {
    Travertine: /travertine/i,
    Marble: /marble|carrara|carrera|calacatta|calcatta|calcatta|rosso|verde|verdy|arabescato|emperador|thassos|pietra|grand antique|gucci|sofita|tundra|alicante|panda|portoro/i,
    Onyx: /onyx/i, Quartzite: /quartzite/i, Granite: /granite/i,
    Fabric: /fabric|linen|velvet|canopy/i, Ceramic: /ceramic/i,
    Brass: /brass/i, Wood: /wood|bamboo|rattan|walnut/i, Metal: /metal|steel|aluminium|aluminum/i, Glass: /glass/i
  };
  const typeOrder = ['Tables','Accessories','Lighting','Umbrellas','Tiles','Furniture & Mirrors','Basins & Sinks'];
  const brandOrder = ['CARVINGS','LA LUZ','ATOMS','BLOC'];
  function optionText(options) {
    return (options || []).flatMap(option => (option.values || []).map(value => typeof value === 'object' ? value.name || value.value || '' : value));
  }
  function normalize(raw) {
    const tags = (raw.tags || []).map(String);
    const lowered = tags.map(tag => tag.toLowerCase());
    const type = String(raw.type || '').toLowerCase();
    const title = String(raw.title || '');
    const isTile = /^tiles?$/.test(type) || lowered.includes('tiles') || lowered.includes('tile');
    const isBloc = lowered.includes('bloc') || lowered.includes('stone gallery') || String(raw.vendor || '').toLowerCase() === 'bloc';
    if ((isBloc && !isTile) || /^(blocks?|slabs?|raw materials?)$/.test(type)) return null;
    let productType;
    if (isTile) productType = 'Tiles';
    else if (/umbrella|parasol/i.test(type + ' ' + title)) productType = 'Umbrellas';
    else if (/lamp|chandelier|lighting|applique/i.test(type)) productType = 'Lighting';
    else if (/basin|sink|shower/i.test(type)) productType = 'Basins & Sinks';
    else if (/table/i.test(type)) productType = 'Tables';
    else if (/mirror|furniture|tv unit/i.test(type)) productType = 'Furniture & Mirrors';
    else productType = 'Accessories';
    let primaryBrand;
    if (isTile) primaryBrand = 'BLOC';
    else if (productType === 'Lighting' || productType === 'Umbrellas' || lowered.includes('la luz')) primaryBrand = 'LA LUZ';
    else if (lowered.includes('atoms') || type === 'accessories') primaryBrand = 'ATOMS';
    else primaryBrand = 'CARVINGS';
    const brands = [primaryBrand];
    const values = optionText(raw.options);
    const source = [title, ...tags, ...values, raw.material || ''].join(' ');
    const colors = Object.entries(colorMap).filter(([,color]) => color.pattern.test(source)).map(([name]) => name);
    const materials = Object.entries(materialMap).filter(([,pattern]) => pattern.test(source)).map(([name]) => name);
    const area = isTile ? ['Floorings'] : productType === 'Umbrellas' || lowered.includes('outdoor') || lowered.includes('out door') ? ['Outdoor'] : ['Indoor'];
    return { ...raw, id: String(raw.id), productType, primaryBrand, brands, colors, materials, area, values, minPrice: Number(raw.minPrice), maxPrice: Number(raw.maxPrice), created: Number(raw.created || 0) };
  }
  const escape = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function decodeConfig(value) {
    if (typeof value === 'string') return value.replace(/&(?:amp|lt|gt|quot|apos|#39|#x27);/g, entity => ({'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&apos;':"'",'&#39;':"'",'&#x27;':"'"}[entity]));
    if (Array.isArray(value)) return value.map(decodeConfig);
    if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([key,item]) => [key,decodeConfig(item)]));
    return value;
  }
  function init(root) {
    if (root.dataset.chInitialized) return;
    root.dataset.chInitialized = 'true';
    const q = selector => root.querySelector(selector);
    const qa = selector => Array.from(root.querySelectorAll(selector));
    const config = decodeConfig(JSON.parse(q('[data-ch-config]').textContent));
    const initial = JSON.parse(q('[data-ch-products]').textContent);
    const labels = config.labels;
    const grid = q('[data-ch-grid]');
    const search = q('[data-ch-search]');
    const minPrice = q('[data-ch-price-min]');
    const maxPrice = q('[data-ch-price-max]');
    const sort = q('[data-ch-sort]');
    const selections = { type: new Set(), brands: new Set(), colors: new Set(), area: new Set(), materials: new Set() };
    let catalogue = initial.products.map(normalize).filter(Boolean), visibleLimit = config.perPage, ready = initial.pages === 1;
    const label = (name, values = {}) => Object.entries(values).reduce((s,[key,value]) => s.replaceAll('[' + key + ']', String(value)), labels[name]);
    const nameFor = (group,value) => group === 'type' ? config.types[value] || value : group === 'area' ? config.areas[value] || value : group === 'colors' ? config.colors[value] || value : group === 'materials' ? config.materials[value] || value : value;
    const priceFor = cents => config.currency + ' ' + (cents / 100).toLocaleString(undefined, {maximumFractionDigits:2});
    function syncFromUrl() {
      const params = new URLSearchParams(location.search);
      for (const [group,set] of Object.entries(selections)) {
        set.clear(); params.getAll('ch_' + group).forEach(value => set.add(value));
      }
      search.value = params.get('ch_q') || '';
      minPrice.value = params.get('ch_min') || ''; maxPrice.value = params.get('ch_max') || '';
      const sorting = params.get('ch_sort') || 'featured';
      if (Array.from(sort.options).some(option => option.value === sorting)) sort.value = sorting;
    }
    function syncUrl() {
      const url = new URL(location.href);
      for (const key of Array.from(url.searchParams.keys())) if (key.startsWith('ch_')) url.searchParams.delete(key);
      url.searchParams.delete('page');
      for (const [group,set] of Object.entries(selections)) for (const value of set) url.searchParams.append('ch_' + group,value);
      if (search.value.trim()) url.searchParams.set('ch_q',search.value.trim());
      if (minPrice.value) url.searchParams.set('ch_min',minPrice.value);
      if (maxPrice.value) url.searchParams.set('ch_max',maxPrice.value);
      if (sort.value !== 'featured') url.searchParams.set('ch_sort',sort.value);
      history.replaceState(null,'',url);
    }
    function passes(product, except) {
      const term = search.value.trim().toLowerCase();
      if (term && ![product.title,product.primaryBrand,...product.brands,...product.colors,...product.materials,...product.values].join(' ').toLowerCase().includes(term)) return false;
      const min = minPrice.value === '' ? 0 : Math.max(0,Number(minPrice.value)) * 100;
      const max = maxPrice.value === '' ? Infinity : Math.max(0,Number(maxPrice.value)) * 100;
      if (min > max || product.maxPrice < min || product.minPrice > max) return false;
      for (const [group,set] of Object.entries(selections)) {
        if (group === except || !set.size) continue;
        const values = group === 'type' ? [product.productType] : product[group];
        if (!values.some(value => set.has(value))) return false;
      }
      return true;
    }
    function createOptions() {
      const present = (group,value) => catalogue.some(product => (group === 'type' ? [product.productType] : product[group]).includes(value));
      const groups = {
        type: typeOrder.filter(value => present('type',value)), brands: brandOrder.filter(value => present('brands',value)),
        colors: Object.keys(colorMap).filter(value => present('colors',value)),
        area: ['Outdoor','Indoor','Floorings'].filter(value => present('area',value)),
        materials: Object.keys(materialMap).filter(value => present('materials',value))
      };
      for (const [group,values] of Object.entries(groups)) {
        const fieldset = q('[data-ch-options="' + group + '"]');
        const legend = fieldset.querySelector('legend')?.outerHTML || '';
        fieldset.innerHTML = legend + values.map(value => '<label class="filter-option"><input type="checkbox" data-ch-facet="' + group + '" value="' + escape(value) + '" aria-label="' + escape(nameFor(group,value)) + '">' + (group === 'colors' ? '<span class="color-dot" aria-hidden="true" style="--swatch:' + colorMap[value].swatch + '"></span>' : '') + '<span class="option-name">' + escape(nameFor(group,value)) + '</span><span class="facet-count" aria-hidden="true"></span></label>').join('');
        fieldset.disabled = !ready;
      }
      maxPrice.placeholder = Math.ceil(Math.max(...catalogue.map(p => p.maxPrice),0) / 100).toLocaleString();
    }
    function card(product,index) {
      const image = product.image ? '<img src="' + escape(product.image) + '" srcset="' + escape(product.imageSmall) + ' 320w, ' + escape(product.image) + ' 640w" sizes="(min-width:1180px) 25vw, (min-width:760px) 28vw, 50vw" width="640" height="800" alt="' + escape(product.imageAlt || product.title) + '" loading="' + (index < 3 ? 'eager' : 'lazy') + '"' + (index === 0 ? ' fetchpriority="high"' : '') + '>' : '<span class="missing-image">' + escape(product.title) + '</span>';
      const swatches = product.colors.slice(0,5).map(color => '<span aria-hidden="true" style="--swatch:' + colorMap[color].swatch + '"></span>').join('');
      return '<article class="product-card"><a href="' + escape(product.url) + '"><div class="product-photo">' + image + '</div><div class="product-caption"><p class="product-brand">' + escape(product.primaryBrand) + '</p><h2 class="product-title">' + escape(product.title) + '</h2><p class="product-price">' + (product.minPrice < product.maxPrice ? escape(labels.starting) + ' ' : '') + escape(priceFor(product.minPrice)) + '</p><div class="product-meta"><div class="product-swatches" aria-label="' + escape(product.colors.join(', ')) + '">' + swatches + '</div><span>' + escape(nameFor('type',product.productType)) + '</span></div></div></a></article>';
    }
    function render() {
      const matched = catalogue.filter(product => passes(product));
      if (sort.value === 'price-asc') matched.sort((a,b) => a.minPrice-b.minPrice);
      if (sort.value === 'price-desc') matched.sort((a,b) => b.minPrice-a.minPrice);
      if (sort.value === 'name') matched.sort((a,b) => a.title.localeCompare(b.title));
      if (sort.value === 'newest') matched.sort((a,b) => b.created-a.created);
      const shown = matched.slice(0,visibleLimit);
      grid.innerHTML = shown.map(card).join('');
      if (!matched.length) grid.innerHTML = '<div class="empty-results"><h3>' + escape(labels.empty) + '</h3><button type="button" data-ch-clear>' + escape(labels.clear) + '</button></div>';
      qa('[data-ch-result-count]').forEach(el => el.textContent = label('products',{count:matched.length}));
      q('[data-ch-page-count]').textContent = label('showing',{shown:shown.length,count:matched.length});
      q('[data-ch-pagination]').hidden = !matched.length;
      q('[data-ch-load-more]').hidden = shown.length >= matched.length;
      q('[data-ch-apply-filters]').textContent = label('view',{count:matched.length});
      const chips = [];
      for (const [group,set] of Object.entries(selections)) for (const value of set) chips.push('<button class="filter-chip" type="button" data-ch-remove="' + group + '" data-ch-value="' + escape(value) + '" aria-label="' + escape(label('remove',{value:nameFor(group,value)})) + '"><span>' + escape(nameFor(group,value)) + '</span><span aria-hidden="true">×</span></button>');
      if (minPrice.value || maxPrice.value) chips.push('<button class="filter-chip" type="button" data-ch-remove-price><span>' + escape(config.currency + ' ' + (minPrice.value || '0') + ' – ' + (maxPrice.value || labels.any)) + '</span><span aria-hidden="true">×</span></button>');
      q('[data-ch-chips]').innerHTML = chips.join(''); q('[data-ch-chips]').hidden = !chips.length;
      q('[data-ch-active-count]').textContent = chips.length ? '(' + chips.length + ')' : '';
      q('[data-ch-price-error]').hidden = !(minPrice.value && maxPrice.value && Number(minPrice.value) > Number(maxPrice.value));
      qa('[data-ch-facet]').forEach(input => {
        const group = input.dataset.chFacet;
        const count = catalogue.filter(product => passes(product,group) && (group === 'type' ? [product.productType] : product[group]).includes(input.value)).length;
        input.checked = selections[group].has(input.value); input.disabled = !ready || (!count && !input.checked);
        input.closest('label').querySelector('.facet-count').textContent = count;
      });
    }
    function reset() { Object.values(selections).forEach(set => set.clear()); search.value = ''; minPrice.value = ''; maxPrice.value = ''; visibleLimit = config.perPage; syncUrl(); render(); }
    function changed() { visibleLimit = config.perPage; syncUrl(); render(); }
    root.addEventListener('change',event => {
      const input = event.target;
      if (input.matches('[data-ch-facet]')) {
        const set = selections[input.dataset.chFacet]; input.checked ? set.add(input.value) : set.delete(input.value); changed();
      } else if ([minPrice,maxPrice,sort].includes(input)) changed();
    });
    let debounce;
    search.addEventListener('input',() => { clearTimeout(debounce); debounce = setTimeout(changed,140); });
    root.addEventListener('click',event => {
      if (event.target.closest('[data-ch-clear]')) { reset(); return; }
      const remove = event.target.closest('[data-ch-remove]');
      if (remove) { selections[remove.dataset.chRemove].delete(remove.dataset.chValue); changed(); q('[data-ch-clear]').focus(); }
      if (event.target.closest('[data-ch-remove-price]')) { minPrice.value = ''; maxPrice.value = ''; changed(); }
    });
    q('[data-ch-load-more]').addEventListener('click',() => { visibleLimit += config.perPage; render(); });
    const toggle = q('[data-ch-toggle-filters]'), side = q('.filter-sidebar');
    function showFilters(open) { side.classList.toggle('is-open',open); toggle.setAttribute('aria-expanded',String(open)); }
    toggle.addEventListener('click',() => showFilters(!side.classList.contains('is-open')));
    q('[data-ch-apply-filters]').addEventListener('click',() => { showFilters(false); toggle.focus(); });
    const popstate = () => { syncFromUrl(); visibleLimit = config.perPage; render(); };
    window.addEventListener('popstate',popstate);
    root.addEventListener('shopify:section:unload',() => window.removeEventListener('popstate',popstate),{once:true});
    syncFromUrl();
    createOptions();
    render();
    if (!ready) {
      const status = q('[data-ch-catalogue-status]'); status.hidden = false; status.textContent = labels.loading;
      search.disabled = minPrice.disabled = maxPrice.disabled = sort.disabled = true;
      (async() => {
        const pages = new Map([[initial.page,initial.products]]);
        for (let page=1;page<=initial.pages;page++) {
          if (page === initial.page) continue;
          const url = new URL(root.dataset.collectionUrl,location.origin);
          url.searchParams.set('section_id',root.dataset.sectionId); url.searchParams.set('page',String(page));
          const nativeSort = new URLSearchParams(location.search).get('sort_by'); if (nativeSort) url.searchParams.set('sort_by',nativeSort);
          const theme = new URLSearchParams(location.search).get('preview_theme_id'); if (theme) url.searchParams.set('preview_theme_id',theme);
          const response = await fetch(url,{credentials:'same-origin'});
          if (!response.ok) throw new Error('Catalogue request failed');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const data = doc.querySelector('[data-ch-products]'); if (!data) throw new Error('Catalogue data missing');
          pages.set(page,JSON.parse(data.textContent).products);
        }
        const all = new Map(Array.from(pages.entries()).sort((a,b) => a[0]-b[0]).flatMap(([,products]) => products).map(normalize).filter(Boolean).map(product => [product.id,product]));
        catalogue = Array.from(all.values()); ready = true;
        search.disabled = minPrice.disabled = maxPrice.disabled = sort.disabled = false;
        status.hidden = true; createOptions(); render();
      })().catch(() => { status.textContent = labels.loadError; });
    }
  }
  function initialize(scope=document) { scope.querySelectorAll('[data-ch-shop-all]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initialize(),{once:true}); else initialize();
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();
